import React, { useState } from 'react';
import './AccountModals.css';

const ChangeEmailModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    newEmail: '',
    password: ''
  });
  const [error, setError] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    try {
      await onSubmit(formData);
      onClose();
      setFormData({ newEmail: '', password: '' });
    } catch (error) {
      console.log('Error object:', error);
      // Update this line to properly extract the error message
      setError(error.detail || 'Failed to update email');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Change Email</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="newEmail"
            placeholder="New Email"
            value={formData.newEmail}
            onChange={(e) => setFormData({...formData, newEmail: e.target.value})}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Current Password"
            value={formData.password}
            onChange={(e) => setFormData({...formData, password: e.target.value})}
            required
          />
          <div className="modal-buttons">
            <button type="submit">Update Email</button>
            <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeEmailModal; 